import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Main from './component/Main'; 
import Leadership from './component/Leadership';
import PrivacyPolicy from './component/privacypolicy';
import SignupPolicy  from './component/signuppolicy';
import TermsUse from './component/TermsUse';
import Disclaimer from './component/Disclaimer';

import News from './component/News'; 
import Contact from './component/Contact'; 
import New from './component/New';
 

function App() {
  return (
    <Router>
      <div className="App">
        {/* Language Translator Dropdown */}
        {/* <div id="google_translate_element" style={{ margin: "10px" }}></div> */}

        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route path="/signuppolicy" element={<SignupPolicy />} />
          <Route path="/termsuse" element={<TermsUse />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/leadership" element={<Leadership />} /> 
         
          <Route path="/news" element={<News />} />
          <Route path="/contact" element={<Contact />} />
          
          <Route path="/new/:id" element={<New />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
